module.exports = __webpack_public_path__ + "static/media/04.2f01d9e6.png";